import React, {useEffect,useState} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Dialog from "@material-ui/core/Dialog";
import {DialogTitle} from "../../../components";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button"; 
import SalePayment from "./salePayment";
import {MaterialTable} from '../../../components';
import Icon from '@material-ui/core/Icon';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(2, 0)
    }
}));

let currentPayment = undefined
let editPaymentMode = false
const SalePayementDetails = ({onPaymentEdit, data ,banks,   handlePaymentDetailsClose, showPaymentDetailsDialog, onSalePaymentSave,
     onSalePaymentDelete, loading}) => {
    const classes = useStyles();
    const [showPaymentDialog, setShowPaymentDialog] = useState(false)
    const [lineSalePayments, setLineSalePayments] = useState([])

    const reset = () => {
        console.log(data)
        if(showPaymentDetailsDialog && data !== undefined && data.lineSalePayments !== undefined && data.lineSalePayments !== null){
            console.log("when page refresh",data)
            setLineSalePayments(data.lineSalePayments);
        }else{
            setLineSalePayments([])
        }
    };
    useEffect(reset, [showPaymentDetailsDialog,data]);


    function onNewPayment(event) {
        editPaymentMode = false;
        event.preventDefault();
        setShowPaymentDialog(true);
    } 

    function onEdit(rowData) {
        rowData = {
            ...rowData,
            bankIndex:banks.findIndex((bank)=>{return bank.id === rowData.paymentBankId;})
        };
        currentPayment = rowData
        editPaymentMode = true
        setShowPaymentDialog(true);
    }

    function onPaymentDelete(rowData) {
        console.debug(rowData,lineSalePayments)
        let index = lineSalePayments.findIndex((srcSalePayment) => {
            return srcSalePayment.id === rowData.id;
        });
        let newLineSalePayments = lineSalePayments;
        newLineSalePayments.splice(index, 1); 
        console.debug(newLineSalePayments)
        setLineSalePayments(newLineSalePayments)
        let tempCurrentData = {
            ...data,
            lineSalePayments :newLineSalePayments
        }
        onSalePaymentDelete(rowData, tempCurrentData)
        console.debug(lineSalePayments)
    }


    function onPaymentSave(payment) {
        console.log(payment,data)
        console.log(lineSalePayments)
        if(editPaymentMode){
            let index = lineSalePayments.findIndex((srcPayement) => {
                return srcPayement.id === payment.id;
            });
            setLineSalePayments([...lineSalePayments.slice(0, index),
                {...payment},
                ...lineSalePayments.slice(index + 1)])
    
            let tempCurrentData ={
                ...data,
                lineSalePayments :[...lineSalePayments.slice(0, index),
                    {...payment},
                    ...lineSalePayments.slice(index + 1)]
            }

            onPaymentEdit(payment, tempCurrentData)
        }else{
            payment = {
                ...payment,
                saleId : data.id
            }
            /* setLineSalePayments([
                ...lineSalePayments, {...payment}]) */
            onSalePaymentSave(payment)
        }
        setShowPaymentDialog(false);
        console.debug(lineSalePayments)
    }


    function handlePaymentClose() {
        currentPayment = undefined;
        setShowPaymentDialog(false);
    }

    let actions = [
        rowData => ({
            icon: () => <Icon color='primary'>edit</Icon>,
            tooltip: 'Edit sale Details',
            onClick: (event, rowData) => onEdit(rowData),
            hidden:rowData.paymentNote === "Bulk Payment" || rowData.paymentNote === "Payment received for TDS" || rowData.paymentNote === "Payment made for TCS" ? true : false
        }),
        rowData => ({
            icon: () => <Icon color='error'>delete</Icon>,
            tooltip: 'Delete sale Details',
            onClick: (event, rowData) => onPaymentDelete(rowData),
            hidden:rowData.paymentNote === "Bulk Payment" || rowData.paymentNote === "Payment received for TDS" || rowData.paymentNote === "Payment made for TCS" ? true : false
        })
    ]
    return <Dialog maxWidth='md' open={showPaymentDetailsDialog} onClose={handlePaymentDetailsClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog- title"   >Sale Payments</DialogTitle>
          <DialogContent  >
            <div className={classes.button} >
                <Button variant="contained" color="primary" onClick={onNewPayment}>Add Payment</Button>
            </div>

            <MaterialTable
            isLoading={loading}
            columns={[
                {title: 'id', field: 'id', hidden: true},
                {title: 'Payment Date', field: 'paymentDate',  editable: 'never',
                render: rowData => {
                    return <span>{moment(rowData.paymentDate).format("DD-MM-YYYY")}</span>
                }
                },
                {title: 'Payment Amount', field: 'paymentAmount',  editable: 'never', render: (rowData) => {
                    return <span>{Math.round(rowData.paymentAmount)}</span>
                }},
                {title: 'Payment Mode', field: 'paymentMode', editable: 'never',
                render: rowData => {
                    return <span>{rowData.paymentMode === 0 ? '' : (rowData.paymentMode === 1 ? 'Cash' : rowData.paymentBankName.String)}</span>
                }
                },
                {title: 'paymentBankId', field: 'paymentBankId', editable: 'never', hidden: true},
                {title: 'Payment Note', field: 'paymentNote', editable: 'never'},
            ]}
            data={lineSalePayments}
            options={{
                actionsColumnIndex: -1,
                search: false,
                showTitle: false,
                
                toolbar: false,
                paging:false
            }} 
            //style={{boxShadow: 'unset'}}
            actions={actions}
            /> 

            {showPaymentDialog ? 

                <SalePayment banks={banks} data={currentPayment} onSave={onPaymentSave} handlePaymentClose={handlePaymentClose} 
                showPaymentDialog={showPaymentDialog} editMode={editPaymentMode} >
                </SalePayment> 

                : null
            }
            <DialogActions>
                <Button
                    className={classes.button}
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                    onClick={handlePaymentDetailsClose}
                >
                    Close
                </Button>
            </DialogActions>
        </DialogContent>
    </Dialog>
};

export default SalePayementDetails;